/**
 * Allow activating a dynamically-inserted ProseMirrorEditorHandle to use the CharCounter.
 */
export function activateOnEditor(handle) {
   const form = handle.el.getParent('form');
   if (!form || !form.getElements('.maxCharacters')) {
      // Missing counter el, nothing to be done
      return;
   }
   const countElements = form.getElements('.maxCharacters');
   const countElement = countElements.find(
      el => el.getProperty('data-textarea-id') === handle.el.id
   );

   countElement.hide();

   handle.editable.addEvents({
      keyup: onKeyup(countElement, () => handle.text),
      focus() {
         handle.editable.fireEvent('keyup');
         countElement.show();
      },
      blur() {
         countElement.hide();
      },
   });
}

function onKeyup(countElement, getter) {
   const [minChars, maxChars] = charCounts(countElement);

   return function(e) {
      let text = getter();
      let typed = text.replace(/\r\n?/, '\n').length;
      let charsLeft = maxChars - typed;
      let updateClass;

      if (charsLeft == maxChars) {
         // There's nothing to count yet, so we don't show the counter.
         countElement.set('text', charsLeft);
         countElement.hide();
      } else if (typed < minChars) {
         /* Translators: %1 -> number of characters; */
         countElement.set('text', _js('%1 too short', minChars - typed));
         updateClass = typed - minChars < 0 ? 'addClass' : 'removeClass';
         countElement[updateClass]('maxCharLength');
         countElement.show();
      } else if (charsLeft < 0) {
         /* Translators: %1 -> number of characters; */
         countElement.set('text', _js('%1 too long', Math.abs(charsLeft)));
         updateClass = charsLeft < 0 ? 'addClass' : 'removeClass';
         countElement[updateClass]('maxCharLength');
         countElement.show();
      } else {
         countElement.set('text', charsLeft);
         // If there are no chars left, add the maxCharLength class.
         updateClass = charsLeft < 0 ? 'addClass' : 'removeClass';
         countElement[updateClass]('maxCharLength');
         countElement.show();
      }
   };
}

function charCounts(countElement) {
   const minChars = parseInt(countElement.getProperty('data-minimum'), 10);
   const maxChars = parseInt(countElement.get('text'), 10);
   return [minChars, maxChars];
}
